export default __webpack_public_path__ + "fonts/ZhongQiChenWeiXunYingBiXingShu-2.ttf.subset.77006ab.ttf";